import React from 'react';
import RootSvg, { RootSvgProps } from './RootSvg';

export default function SvgWechat(props: RootSvgProps) {
  return (
    <RootSvg
      width="29"
      height="28"
      viewBox="0 0 29 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="14.5" cy="14" r="14" fill="#E3FDE3" />
      <g clipPath="url(#clip0_5806_95553)">
        <path
          d="M22.2922 15.8117C22.2922 13.6055 20.0844 11.8086 17.6063 11.8086C14.9813 11.8086 12.9141 13.607 12.9141 15.8117C12.9141 18.0211 14.9813 19.8148 17.6063 19.8148C18.1563 19.8148 18.7109 19.6758 19.2625 19.5383L20.775 20.3664L20.3594 18.9883C21.4672 18.157 22.2922 17.0555 22.2922 15.8117ZM16.1547 15.1992C15.8094 15.1992 15.5297 14.9195 15.5297 14.5742C15.5297 14.2289 15.8094 13.9492 16.1547 13.9492C16.5 13.9492 16.7797 14.2289 16.7797 14.5742C16.7797 14.918 16.5 15.1992 16.1547 15.1992ZM19.1906 15.1945C18.8453 15.1945 18.5656 14.9148 18.5656 14.5695C18.5656 14.2242 18.8453 13.9445 19.1906 13.9445C19.5359 13.9445 19.8156 14.2242 19.8156 14.5695C19.8156 14.9148 19.5359 15.1945 19.1906 15.1945Z"
          fill="#00C800"
        />
        <path
          d="M12.2223 7.67188C9.18945 7.67188 6.70508 9.73906 6.70508 12.3641C6.70508 13.8797 7.53164 15.1234 8.91289 16.0891L8.36133 17.7484L10.2895 16.7813C10.9801 16.9172 11.5332 17.0578 12.2223 17.0578C12.3957 17.0578 12.5676 17.05 12.7379 17.0359C12.6301 16.6672 12.5676 16.2813 12.5676 15.8797C12.5676 13.4688 14.6379 11.5125 17.2582 11.5125C17.4379 11.5125 17.6145 11.525 17.7895 11.5453C17.3113 9.32344 14.9348 7.67188 12.2223 7.67188ZM10.3691 11.4578C9.95508 11.4578 9.61914 11.1219 9.61914 10.7078C9.61914 10.2938 9.95508 9.95781 10.3691 9.95781C10.7832 9.95781 11.1191 10.2938 11.1191 10.7078C11.1191 11.1219 10.7832 11.4578 10.3691 11.4578ZM14.2223 11.4578C13.8082 11.4578 13.4723 11.1219 13.4723 10.7078C13.4723 10.2938 13.8082 9.95781 14.2223 9.95781C14.6363 9.95781 14.9723 10.2938 14.9723 10.7078C14.9723 11.1219 14.6363 11.4578 14.2223 11.4578Z"
          fill="#00C800"
        />
      </g>
      <defs>
        <clipPath id="clip0_5806_95553">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(6.5 6)"
          />
        </clipPath>
      </defs>
    </RootSvg>
  );
}
